import { FormattedMessage } from 'react-intl';
import { SharedPaymentGroupDto } from 'types/invoices';
import { AlertActionButton, DetailsAlert } from '../layout/views/details-tab/Details';
import { formatShareRate } from './paymentShare';

interface Props {
    group: SharedPaymentGroupDto;
    onOpenPaymentDistribution: () => void;
}

/** A copy of a group whose shares do not add up to 100 %, which no copy can be sent with. */
export function SharedPaymentIncompleteAlert({ group, onOpenPaymentDistribution }: Props) {
    return (
        <DetailsAlert
            tone="error"
            action={
                <AlertActionButton onClick={onOpenPaymentDistribution}>
                    <FormattedMessage id="invoices.payment-distribution.button" />
                </AlertActionButton>
            }
        >
            <p>
                <FormattedMessage
                    id="invoices.shared-payment.incomplete-title"
                    values={{ total: formatShareRate(group.shareTotal) }}
                />
            </p>
            <p className="font-normal">
                <FormattedMessage
                    id={
                        group.isLocked
                            ? 'invoices.shared-payment.incomplete-locked-description'
                            : 'invoices.shared-payment.incomplete-description'
                    }
                />
            </p>
        </DetailsAlert>
    );
}
